import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
import { getDefaultUserAgentKey, getPlatformSpecificData } from "./msRestUserAgentPolicy";
import { Constants } from "../util/constants";
import { HttpHeaders } from "../httpHeaders";

function getRuntimeInfo() {
  var msRestRuntime = {
    key: "core-http",
    value: Constants.coreHttpVersion
  };
  return [msRestRuntime];
}

function getUserAgentString(telemetryInfo) {
  var keySeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
  var valueSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/";
  return telemetryInfo.map(function (info) {
    var value = info.value ? "".concat(valueSeparator).concat(info.value) : "";
    return "".concat(info.key).concat(value);
  }).join(keySeparator);
}

export var getDefaultUserAgentHeaderName = getDefaultUserAgentKey;
/**
 * The default approach to generate user agents.
 * Uses static information from this package, plus system information available from the runtime.
 */

export function getDefaultUserAgentValue() {
  var runtimeInfo = getRuntimeInfo();
  var platformSpecificData = getPlatformSpecificData();
  var userAgent = getUserAgentString(runtimeInfo.concat(platformSpecificData));
  return userAgent;
}
/**
 * Returns a policy that adds the user agent header to outgoing requests based on the given {@link TelemetryInfo}.
 * @param userAgentData - Telemetry information.
 * @returns A new {@link UserAgentPolicy}.
 */

export function userAgentPolicy(userAgentData) {
  var key = !userAgentData || userAgentData.key === undefined || userAgentData.key === null ? getDefaultUserAgentKey() : userAgentData.key;
  var value = !userAgentData || userAgentData.value === undefined || userAgentData.value === null ? getDefaultUserAgentValue() : userAgentData.value;
  return {
    create: function create(nextPolicy, options) {
      return new UserAgentPolicy(nextPolicy, options, key, value);
    }
  };
}
/**
 * A policy that adds the user agent header to outgoing requests based on the given {@link TelemetryInfo}.
 */

export var UserAgentPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(UserAgentPolicy, _BaseRequestPolicy);

  var _super = _createSuper(UserAgentPolicy);

  function UserAgentPolicy(_nextPolicy, _options, headerKey, headerValue) {
    var _this;

    _classCallCheck(this, UserAgentPolicy);

    _this = _super.call(this, _nextPolicy, _options);
    _this._nextPolicy = _nextPolicy;
    _this._options = _options;
    _this.headerKey = headerKey;
    _this.headerValue = headerValue;
    return _this;
  }

  _createClass(UserAgentPolicy, [{
    key: "sendRequest",
    value: function sendRequest(request) {
      this.addUserAgentHeader(request);
      return this._nextPolicy.sendRequest(request);
    }
    /**
     * Adds the user agent header to the outgoing request.
     */

  }, {
    key: "addUserAgentHeader",
    value: function addUserAgentHeader(request) {
      if (!request.headers) {
        request.headers = new HttpHeaders();
      }

      if (!request.headers.get(this.headerKey) && this.headerValue) {
        request.headers.set(this.headerKey, this.headerValue);
      }
    }
  }]);

  return UserAgentPolicy;
}(BaseRequestPolicy);